import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities } from 'redux-modules/entity'

import api from 'api'

const FETCH_REQUEST = 'realhub/activity/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/activity/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/activity/FETCH_FAILURE'

// Initial State
const initialState = {
  result: [],
  loaded: false,
  loading: false,
  loadedActivityForEntities: [],
  errors: [],
}

// Actions
export function fetchRequest(payload = {}){
  return {
    type: FETCH_REQUEST,
    loading: true,
    loadedActivityForEntities: payload.loadedActivityForEntities,
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    loading: false,
    loaded: true,
    errors: [],
    result: payload.result,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    loaded: false,
    loading: false,
    errors,
  }
}

// Action Creators
export function loadEntityActivity(entityType, entityId, options, callback){
  let url
  switch (entityType){
    case 'LayoutTemplate':
      url = `/admin/layout_templates/${entityId}/activity.json`
      break
    case 'ProviderPriceList':
      url = `/admin/provider_price_lists/${entityId}/activity.json`
      break
    case 'TemplatePage':
      url = `/admin/template_pages/${entityId}/activity.json`
      break
    case 'TemplatePagePartial':
      url = `/admin/template_page_partials/${entityId}/activity.json`
      break
    case 'ProviderPackage':
      url = `/admin/provider_packages/${entityId}/activity.json`
      break
    default:
      url = ''
      break
  }

  const entityKey = `${entityType}${entityId}`

  return (dispatch, getState) => {
    // Set Loading
    const loadedActivityForEntities = getState().activities.loadedActivityForEntities
      ? getState().activities.loadedActivityForEntities.slice() : []

    const index = loadedActivityForEntities.indexOf(entityKey)
    if (index === -1){
      loadedActivityForEntities.push(entityKey)
    }
    dispatch(fetchRequest({ loadedActivityForEntities }))

    const promise = api(url, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.ACTIVITY_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess({ result: normalizedJson.result }))

        if (callback) callback(json)

        return json
      })
      .catch((json) => {
        const errors = json.errors ? json.errors : ['Something went wrong...']
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        loadedActivityForEntities: action.loadedActivityForEntities || state.loadedActivityForEntities,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.result,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors,
      }
    default:
      return state
  }
}
